setTimeout(() => {
  $(".navi.burger").on( "click", function() {
    if ( $('.icon-search-wrap .icon-close').is(":visible")) {
      $(".navi.search .icon-search-wrap").click(); 
    }

    $(".navi.burger svg").toggle();
    // Trigger
    $('.hidden-menu').removeClass('notransition');
    $('header').toggleClass('open');
    if ( ($(window).width() < 1199) ) {
      $('body').toggleClass('noscroll');
    } else {
      $('body').removeClass('noscroll');
    }
    $('.hidden-menu nav').toggleClass('d-none');
    $('.hidden-menu').toggleClass('h0');

    var headerHeightFixed = $('body').find('header').outerHeight();
    if ( $(this).parents('header').hasClass('open') ) {
      $('#MainContent').css('padding-top',  headerHeightFixed+'px');
    } else {
      $('#MainContent').removeAttr("style");
    }
  });

  $(window).on('load', function() {
   $('header').find('.mobile-search-wrap').removeClass('d-none');
  });

  // Search
  $(window).on("resize", function () {
    var headerHeight = $('body').find('header').outerHeight();
    scrollPositionSearchBox(headerHeight);
  }).resize();

  function scrollPositionSearchBox(height) {
    if ( $('header').hasClass('open') ) {
      $('header').find('.mobile-search-wrap').css('top', height+'px');
    }
  }

  $(".navi.search .icon-search-wrap").click(function(){
    if ( $('.burger .icon-close').is(":visible")) {
       $(".navi.burger").click(); 
    }
    $('.navi.search form').toggleClass('d-none');
    $(".navi.search .icon-s").toggle();
    $('.mobile-search-wrap').toggleClass('h0');
    $('header').toggleClass('open-mobile-search');
    $('.mobile-search-wrap').removeClass('notransition');

  });
}, 50)
